import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import logService from "../../../services/logService";
import ActionCell from "./components/ActionCell";
import { formatDate } from "../../../utils/formatDate";

function LogList() {
  const [logs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLogs(page, limit, search);
  }, [page, limit, search]);

  const fetchLogs = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await logService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "action,ip",
        select: "createdAt,user,action,ip"
      });
      setLogs(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching logs:", error);
      setLoading(false);
    }
  };

  const columns = [
    { Header: "Fecha", accessor: "createdAt", align: "left" },
    { Header: "Usuario", accessor: "user", align: "left" },
    { Header: "Acción", accessor: "action", align: "left" },
    { Header: "IP", accessor: "ip", align: "left" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = logs.map((log) => ({
    createdAt: <MDTypography variant="button" fontWeight="medium">{formatDate(log.createdAt)}</MDTypography>,
    user: <MDTypography variant="caption">{log.user?.username || "Usuario desconocido"}</MDTypography>,
    action: <MDTypography variant="caption">{log.action}</MDTypography>,
    ip: <MDTypography variant="caption">{log.ip}</MDTypography>,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={log._id} action="details" icon="visibility" color="info" />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Auditoría</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default LogList;